import React, { useState } from "react";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { Button, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

import DocumentPreviewModal from "Components/Common/DocumentPreviewModal";
import InputFieldText from "Components/Common/InputFieldText";
import Backdrop from "Components/Common/Backdrop";

import getFileExtension from "utils/getFileExtension";

import { usePostUploadUserDocuments } from "apis/DocumentType";
import { POWER_READ_ADMIN } from "common/constant";
import { useSelector } from "react-redux";

const validFileFormats = ["jpg", "png", "jpeg", "pdf", "doc", "docx"];

const docFiles = ["docx", "doc"];

const FilterDocuments = ({
  path,
  t,
  handleChange,
  searchedText,
  documentEnumType,
}) => {
  const [documentToPreview, setDocumentToPreview] = useState(null);
  const [uploadedDocument, setUploadedDocument] = useState("");

  const [uploadDocument, { isLoading }] = usePostUploadUserDocuments();
  const { roles } = useSelector((state) => state.Login);
  const isEditDisabled = roles.includes(POWER_READ_ADMIN);

  const handleUploadFile = async (selectedFile) => {
    try {
      const formData = new FormData();
      formData.append("document", selectedFile);
      formData.append("path", path);
      formData.append("adminDocumentType", documentEnumType);
      await uploadDocument(formData);
      setDocumentToPreview(null);
    } catch (error) {}
  };

  const fileChangeHandler = (event) => {
    try {
      const fileExtension = getFileExtension(
        event.target.files[0]?.name
      ).toLowerCase();
      if (!validFileFormats.includes(fileExtension)) {
        toast.error(
          "Invalid file format, Please upload image, pdf or word file"
        );
      } else if (docFiles.includes(fileExtension)) {
        handleUploadFile(event.target.files[0]);
      } else {
        setDocumentToPreview({
          url: URL.createObjectURL(event.target.files[0]),
          documentTypeName: event.target.files[0].name,
          documentType: fileExtension,
          documentName: event.target.files[0].name,
        });
        setUploadedDocument(event.target.files[0]);
      }
      event.target.value = "";
    } catch (err) {}
  };

  if (isLoading) {
    return <Backdrop open />;
  }

  return (
    <>
      {!!documentToPreview && (
        <DocumentPreviewModal
          isOpen
          handleClose={() => setDocumentToPreview(null)}
          isDownloadable={false}
          actionButton={
            <Button
              onClick={() => handleUploadFile(uploadedDocument)}
              color="primary"
              className="mb-1 me-1"
              variant="contained"
              disabled={isLoading}
            >
              {t("Upload")} {isLoading && <CircularProgress size={20} />}
            </Button>
          }
          {...documentToPreview}
        />
      )}
      <div className="d-flex justify-content-between">
        <InputFieldText
          label={t("Search Here")}
          placeholder="Search Here"
          value={searchedText}
          type="search"
          onChange={handleChange}
        />
        {!isEditDisabled && path && (
          <Button
            variant="contained"
            component="label"
            sx={{ height: "fit-content" }}
          >
            {t("Upload")}
            <input
              style={{
                display: "none",
              }}
              accept="image/*, .pdf, .doc, .docx, .PDF, .DOC, .DOCX"
              type="file"
              onChange={fileChangeHandler}
            />
          </Button>
        )}
      </div>
    </>
  );
};

FilterDocuments.propTypes = {
  t: PropTypes.func,
  path: PropTypes.string,
  handleChange: PropTypes.func,
  searchedText: PropTypes.string,
  fileChangeHandler: PropTypes.func,
  documentEnumType: PropTypes.number,
};

export default withTranslation()(FilterDocuments);
